import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { toast } from "react-toastify";
import IsLoadingHOC from "./IsLoadingHOC";
import { authAxios } from "../config/config";
import { BsEye, BsEyeSlash } from "react-icons/bs";

const SetPassword = ({ setLoading }) => {
  const navigate = useNavigate();

  // State for password values and visibility
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSetPassword = async (e) => {
    e.preventDefault();
    
    // Check if the passwords match
    if (password === confirmPassword) {
      const Email = sessionStorage.getItem("email");
      const payload = {
        email: Email.toLowerCase(),
        password: password,
        confirmPassword: confirmPassword,
      };

      setLoading(true); // Start loading before API call
      await authAxios()
        .post(`/auth/set-password`, payload)
        .then((response) => {
          const resData = response?.data;
          setLoading(false); // Stop loading after API call
          if (resData.status === 1) {
            toast.success(resData?.message);
            navigate(`/login`);
          } else {
            toast.error(resData?.message);
          }
        })
        .catch((error) => {
          setLoading(false); // Stop loading in case of error
          toast.error(error?.response?.data?.message || "Something went wrong");
        });
    } else {
      toast.error("The passwords entered do not match.");
    }
  };

  return (
    <div className="flex shadow-lg flex-1 flex-col justify-center px-5 py-6 rounded-[20px] lg:px-5 bg-white border max-w-[400px] mx-auto absolute w-[95%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
      <div className="sm:mx-auto sm:w-full">
        <img
          className="mx-auto h-20 w-auto"
          src="./assets/images/final-logo.png"
          alt="Your Company"
        />
        <h2 className="mt-2 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Set Password
        </h2>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full">
        <form className="space-y-6" onSubmit={handleSetPassword}>
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Password
            </label>
            <div className="mt-2 relative">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <div
                className="absolute top-[12px] right-[15px] cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <BsEyeSlash /> : <BsEye />}
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="confirm-password"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Confirm Password
            </label>
            <div className="mt-2 relative">
              <input
                id="confirm-password"
                name="confirm-password"
                type={showConfirmPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <div
                className="absolute top-[12px] right-[15px] cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <BsEyeSlash /> : <BsEye />}
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IsLoadingHOC(SetPassword);
